import { ShieldOff } from 'lucide-react';

/**
 * Shared "Access Denied" state for client-side role gating. Rendered by pages a
 * given role may reach by direct URL but is not authorised to use, so every such
 * page shows the same coherent state instead of broken chrome or a silent 403.
 */
export function AccessDenied({ message }: { message?: string }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-red-200 bg-white py-24 px-6 text-center gap-4">
      <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-red-50">
        <ShieldOff size={32} className="text-red-400" aria-hidden="true" />
      </div>
      <div>
        <h2 className="text-lg font-semibold text-gray-700">Access Denied</h2>
        <p className="mt-1 text-sm text-gray-400 max-w-sm">
          {message ?? 'You do not have permission to view this page.'}
        </p>
      </div>
    </div>
  );
}
